<template>
    <div>
        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
            <b-spinner label="Loading..."></b-spinner>
        </div>
        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
            {{$t('table.no_records')}}
        </div>
        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
            <div class="row justify-content-end">
                <div class="col-auto pt-2">
                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                </div>
                <div class="col-auto">
                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 overflow-auto">
                    <table v-if="filterObj.summaryType == 'customer'" class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key">{{tblHeader.label}}</th>
                            </tr>
                        </thead>
                        <tbody v-for="(items, i, j) in creditItems" :key="j">
                            <tr class="dtrg-group dtrg-start dtrg-level-0">
                                <td colspan="10" class="text-capitalize">
                                    <span class="text-secondary mr-2"><i class="fas fa-user"></i></span>{{items[0].memberDisplayName}} 
                                </td>
                            </tr>
                            <tr v-for="(item, k) in items" :key="k">
                                <td class="align-middle">{{k+startPage}}</td>
                                <td class="align-middle">{{convertTimestampToDateTime(item.createDate)}}</td>
                                <td class="align-middle">{{item.workID == "" ? "-" : item.workID}}</td>
                                <td class="align-middle">{{item.memberDisplayName}}</td>
                                <td class="align-middle">{{item.mobile}}</td>
                                <td class="align-middle">
                                    <span class="badge" :class="getAction(item.point)== 1 ? 'badge-primary' : 'badge-warning'">{{getAction(item.point)== 1 ? $t('salon_report.credit.top_up') : $t('salon_report.credit.redeem')}}</span>
                                </td>
                                <td class="align-middle">{{item.point}}</td>
                                <td class="align-middle">{{item.finalPoint}}</td>
                                <td class="align-middle">{{getOutletName(item.outletID)}}</td>
                                <!-- <td class="align-middle text-center">
                                    <a class="link d-block text-primary" title="Rollback Points" @click="showDeleteTransaction(item.trxnID)">
                                        <i class="fal fa-backward"></i>
                                    </a>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                    <table v-else class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key">{{tblHeader.label}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, k) in creditItems" :key="k">
                                <td class="align-middle">{{k+startPage}}</td>
                                <td class="align-middle">{{convertTimestampToDateTime(item.createDate)}}</td>
                                <td class="align-middle">{{item.workID == "" ? "-" : item.workID}}</td>
                                <td class="align-middle">{{item.memberDisplayName}}</td>
                                <td class="align-middle">{{item.mobile}}</td>
                                <td class="align-middle">
                                    <span class="badge" :class="getAction(item.point)== 1 ? 'badge-primary' : 'badge-warning'">{{getAction(item.point)== 1 ? $t('salon_report.credit.top_up') : $t('salon_report.credit.redeem')}}</span>
                                </td>
                                <td class="align-middle">{{item.point}}</td>
                                <td class="align-middle">{{item.finalPoint}}</td>
                                <td class="align-middle">{{getOutletName(item.outletID)}}</td>
                                <!-- <td class="align-middle text-center">
                                    <a class="link d-block text-primary" title="Rollback Points" @click="showDeleteTransaction(item.trxnID)">
                                        <i class="fal fa-backward"></i>
                                    </a>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <deleteModal ref="deleteModal" @performConfirmAction="performDeleteAction"></deleteModal>
    </div>
</template>
<script>
import deleteModal from './../../Delete_Modal'
import _ from 'lodash';
import moment from 'moment'
import {handleSessionExpired, setReturnData, getOutletName} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: "pointsList",
    components:{
        deleteModal
    },
    data(){
        return{
            isSpinnerShow: false,
            filterObj: {},
            outlet: [],
            creditItems: {},
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            deleteMessage: "", trxnID: 0, exportData: []
        }
    },
    computed:{
        fields(){
            return[
                {key: "index", label: "#"},
                {key: "date", label: this.$i18n.t('table.header.date')},
                {key: "orderID", label: this.$i18n.t('table.header.order_id')},
                {key: "name", label: this.$i18n.t('table.header.name')},
                {key: "mobile", label: this.$i18n.t('table.header.contact')},
                {key: "action", label: ""},
                {key: "point", label: this.$i18n.t('table.header.point')},
                {key: "balance", label: this.$i18n.t('table.header.balance')},
                {key: "outlet", label: this.$i18n.t('table.header.outlet')},
                // {key: "rollback", label: this.$i18n.t('table.header.rollback')},
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.date')).toUpperCase()] = "date"
            ret[(this.$i18n.t('table.header.order_id')).toUpperCase()] = "orderID"
            ret[(this.$i18n.t('table.header.name')).toUpperCase()] = "name"
            ret[(this.$i18n.t('table.header.contact')).toUpperCase()] = "mobile"
            ret[(this.$i18n.t('table.action')).toUpperCase()] = "action"
            ret[(this.$i18n.t('table.header.point')).toUpperCase()] = "point"
            ret[(this.$i18n.t('table.header.balance')).toUpperCase()] = "balance"
            ret[(this.$i18n.t('table.header.outlet')).toUpperCase()] = "outlet"
            return ret
        },
    },
    watch:{
        "$i18n.locale"(val){
            if(this.$parent.selectedTab == 'list'){
                this.setExportData(this.exportData)
            }
        }
    },
    methods:{
        async closeModal(isError){
            if(!isError){
                var filterObj = this.$parent.filterObj;
                this.$refs.deleteModal.toggleModal = false
                await this.getCreditList(filterObj)
            }
            this.$parent.$parent.isModalShow = false
        },
        convertTimestampToDateTime(date){
            return moment.unix(date).format(this.$msg.CST.DATE_TIME_24)
        },
        getAction(point){
            return Math.sign(point)
        },
        getOutletName(id){
            return getOutletName(id, this.outlet)
        },
        async getCreditList(filterObj){
            let $vm = this;
            this.filterObj = filterObj;
            var dateFilter = "?startCreateDate=" + moment(filterObj.date.startDate).unix() + "&endCreateDate=" + moment(filterObj.date.endDate).unix()
            var outletFilter = filterObj.outletID == "all" ? "" : "&outletID=" + filterObj.outletID;
            var searchFilter = filterObj.search == "" ? "" : "&search=" + filterObj.search
            var typeFilter = filterObj.listType == "all" ? "" : "&" + filterObj.listType + "=1"

            let QUERY_STRING = dateFilter + "&page=" + $vm.page + outletFilter + typeFilter +  searchFilter 
            const url =  this.$api.REPORT_POINTS + QUERY_STRING;

            $vm.isSpinnerShow = true;
            var result = {}
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = setReturnData(response.data.result, response.data.count, $vm.page)
                $vm.creditItems = filterObj.summaryType == 'customer' ? $vm.groupItemsByMemberID(result.result) : result.result;
                $vm.totalEntries = response.data.count;
                $vm.totalPage = result.totalPage;

                $vm.startPage = result.startPage;
                $vm.endPage = result.endPage;
                $vm.isSpinnerShow = false;
                
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            await this.getExportData(dateFilter + outletFilter + typeFilter +  searchFilter )
        },
        groupItemsByMemberID(result){
            var group =  _.groupBy(result, 'memberID')
            return group;
        },
        async getExportData(strFilter){
            let $vm = this;
            const url =  this.$api.REPORT_POINTS + strFilter;

            var result = {}
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            this.exportData = result
            this.setExportData(result)
        },
        setExportData(data){
            var strDate = moment(this.filterObj.date.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(this.filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT)

            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_points`) + "(" + this.$i18n.messages[this.$i18n.locale].tab.reportCreditTabs[1].text + ")" + " " + strDate
            var exportHeaders = [
                this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_points`), 
                this.$i18n.t('table.header.date') + ": " + strDate , 
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), 
                this.$i18n.t('label.outlet') + ": " + (this.filterObj.outletID == "all" ? this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')}) : this.getOutletName(this.filterObj.outletID)),
                " "];
            var exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV

            var exportData = []
            for(var i=0; i<data.length; i++){
                exportData.push({
                    index: i+1,
                    date: this.convertTimestampToDateTime(data[i].createDate),
                    orderID: data[i].workID == "" ? "-" : data[i].workID,
                    name: data[i].memberDisplayName,
                    mobile: data[i].mobile,
                    action: this.getAction(data[i].point) == 1 ? this.$i18n.t('salon_report.credit.top_up') : this.$i18n.t('salon_report.credit.redeem'),
                    point: data[i].point,
                    balance: data[i].finalPoint,
                    outlet: this.getOutletName(data[i].outletID)
                })
            }

            var exportObj = {
                data: exportData,
                fields: this.exportFields,
                headers: exportHeaders,
                fileName: exportFileName
            }
            
            this.$emit('setExportData', exportObj)
        },
        async handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                await this.getCreditList(this.filterObj);
                //document.getElementById('btnToTop').click(); 
            }
        },
        showDeleteTransaction(id){
            this.trxnID = id
            this.$refs.deleteModal.showModal(this.$i18n.t('table.header.rollback'), this.$i18n.t('message.confirmation.rollback_transaction'))
        },
        performDeleteAction(){
            let $vm = this;
            const url =  this.$api.REPORT_POINTS + "/" + this.trxnID + this.$api.DELETE;

            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                if(response.status == 200){
                    var message = $vm.$i18n.t('salon_report.transaction') + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.delete')})
                    $vm.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        }
    },
    mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
   }
}
</script>
